import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({providedIn: 'root'})
export class IpbLoadingService {
	onLoading$ = new BehaviorSubject(false);

	setLoading(value: boolean) {
		this.onLoading$.next(value);
	}
}
